module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fqzTi"))).then(() => module.bundle.root('ewmtE'));